<script>
    import { onMount } from 'svelte';
	import { db } from '../stores.js';
    const ui = firebaseui.auth.AuthUI.getInstance() || new firebaseui.auth.AuthUI(firebase.auth());
    console.log("ui: ", ui);
    const uiConfig = {
        callbacks: {
            signInSuccessWithAuthResult: function(authResult, redirectUrl){
                console.log(authResult);
                // save authResult.additionalUserInfo.providerId and authResult.additionalUserInfo.username
                // under authResult.user.uid
                $db.collection("users").doc(authResult.user.uid).set({
                    provider: authResult.additionalUserInfo.providerId,
                    username: authResult.additionalUserInfo.username,
                    isLoggedIn: true
                }, {merge: true}).then(() => {
                    console.log("User profile successfully saved!");
                    return true;
                }).catch((error) => {
                    console.error("Error saving user profile: ", error);
                });
                // user.set({...$user, ...authResult.additionalUserInfo});
                // return true;
            }
        },
        signInFlow: 'popup',
        signInOptions: [
            firebase.auth.TwitterAuthProvider.PROVIDER_ID,
            firebase.auth.GithubAuthProvider.PROVIDER_ID
        ]
    }
    onMount( async() => {
        ui.start('#firebaseui-auth-container', uiConfig);
    });
</script>

<!-- <section> -->
    <div id="firebaseui-auth-container"></div>
<!-- </section> -->

<style>
    /* section {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    } */

</style>